import { render, staticRenderFns } from "./ControlBar.vue?vue&type=template&id=b8b6181e&scoped=true&"
import script from "./ControlBar.vue?vue&type=script&lang=js&"
export * from "./ControlBar.vue?vue&type=script&lang=js&"
import style0 from "./ControlBar.vue?vue&type=style&index=0&id=b8b6181e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b6181e",
  null
  
)

export default component.exports